import React from "react";

import Heading from "components/heading";

import { CheckIcon, XIcon } from "@heroicons/react/outline";

import HeroSection from "../../hero-section";

const NegativeTrait = ({ children }) => (
  <div className="whitespace-nowrap space-x-3 text-left">
    <div className="inline-block p-1.5 rounded-full shadow-md bg-error text-white align-middle" aria-label="red x icon">
      <XIcon className="h-4 w-4 md:h-5 md:w-5" />
    </div>
    <p className="inline-block">{children}</p>
  </div>
);

const PositiveTrait = ({ children }) => (
  <div className="whitespace-nowrap space-x-3 text-left">
    <div
      className="inline-block p-1.5 rounded-full shadow-md bg-secondary text-white align-middle"
      aria-label="green check icon"
    >
      <CheckIcon className="h-4 w-4 md:h-5 md:w-5" />
    </div>
    <p className="inline-block">{children}</p>
  </div>
);

const negativeTraits = [
  "Disjointed apps",
  "No standardization",
  "Multiple Logins",
  "Lack of Transparency",
  "Inefficient Processes",
  "Can’t scale business",
];

const positiveTraits = [
  "App integration",
  "Consistent info & formats",
  "Single login",
  "Transparency for all",
  "Smooth process",
  "Enables business growth",
];

const title = "Enerflo brings order to solar chaos";

const OrderToChaos = () => (
  <div className="relative overflow-hidden bg-navy-dark">
    <HeroSection title={title} className="flex-col md:space-x-0">
      <HeroSection.Content className="w-full lg:w-3/4 md:text-center">
        <HeroSection.Header className="text-white mt-6 mb-8 md:mb-10 lg:mb-16 lg:mt-8">
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
      </HeroSection.Content>

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 divide-y divide-dashed divide-gray-600 lg:divide-x-2 lg:divide-y-0">
        <div className="pt-0 p-6 pb-10 lg:pt-6 lg:pb-4 space-y-10 lg:space-y-12">
          <div className="text-center text-gray-100 max-w-lg mx-auto">
            <Heading tag="h4" className="text-amber-500 uppercase tracking-wide mb-4 lg:mb-6">
              Without Enerflo
            </Heading>
            <p>
              Countless hours wasted on managing inefficient sales and install processes, cumbersome paperwork and
              disjointed systems
            </p>
          </div>
          <figure className="hidden sm:block relative md:px-8 grow py-2 w-full md:w-4/5 lg:w-full mx-auto">
            {/* Need to use basic img element instead of next/image so svg animation runs properly on safari */}
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img className="w-full h-full" src="/images/without-enerflo.svg" alt="Without Enerflo" />
          </figure>
          <div className="text-center">
            <div className="inline-block text-normal">
              <div className="grid grid-cols-1 xs:grid-cols-2 gap-4 text-gray-100 max-w-lg mx-auto px-2">
                {negativeTraits.map(trait => (
                  <NegativeTrait key={trait}>{trait}</NegativeTrait>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="px-6 py-10 lg:pt-6 lg:pb-4 space-y-10 lg:space-y-12">
          <div className="text-center text-gray-100 max-w-lg mx-auto">
            <Heading tag="h4" className="text-primary uppercase tracking-wide mb-4 md:mb-6">
              With Enerflo
            </Heading>
            <p>
              From lead to PTO, everything flows seamlessly through Enerflo. Bring your favorite tools and make Enerflo
              work harder for you
            </p>
          </div>
          <figure className="hidden sm:block relative pr-2 md:pl-4 md:pr-8 grow w-full md:w-4/5 lg:w-full mx-auto">
            {/* Need to use basic img element instead of next/image so svg animation runs properly on safari */}
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img className="w-full h-full" src="/images/with-enerflo.svg" alt="With Enerflo" />
          </figure>
          <div className="text-center">
            <div className="inline-block mx-auto">
              <div className="grid grid-cols-1 xs:grid-cols-2 gap-4 text-gray-100 max-w-lg mx-auto px-2 md:pl-4">
                {positiveTraits.map(trait => (
                  <PositiveTrait key={trait}>{trait}</PositiveTrait>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </HeroSection>
  </div>
);

export default OrderToChaos;
